import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './in-place-restore.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { DataProtectionVariables } from '../../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'in-place-restore',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./in-place-restore.scss')],
  template: require('./in-place-restore.html')
})

export class InPlaceRestore {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedEntity') selectedEntity;
  @Input('selectedRestorePoint') selectedRestorePoint;
  @Output('onRequestStatusChange') emitter = new EventEmitter();

  private subscribeHandler;
  private active: boolean = true;
  private vmName = '';
  private vcHost = '';

  private isRequestPending: boolean = false;
  private emitData = {
    'status': '',
  };

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit(f: NgForm) {
    this.isRequestPending = true;
    this.emitData.status = 'pending';
    this.emitter.emit(this.emitData);
    this.runInPlaceRestore();
  }

  onCancelButtonClicked() {
    this.emitter.emit();
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if ( changes && changes.selectedEntity ) {
        this.vmName = (this.selectedEntity.name) ? this.selectedEntity.name : '';
        this.vcHost = (this.selectedEntity.vcHost) ? this.selectedEntity.vcHost : '';
    }
    if ( changes && changes.isVisible ) {
      this.reset();
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  runInPlaceRestore() {
    if(this.selectedEntity && this.selectedEntity.entity_id && this.selectedEntity.entity_id !== '' &&
      this.selectedEntity.vcenter_instanceId && this.selectedEntity.vcenter_instanceId !== ''
      && this.selectedRestorePoint && this.selectedRestorePoint.id && this.selectedRestorePoint.id !== '') {

      let inPlaceRestorePayload = {"restorePointId": this.selectedRestorePoint.id,"restoreAttributes":{"ignoreWarnings":"true"}};

      this.subscribeHandler = this.service.runInPlaceRestore(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId, inPlaceRestorePayload)
        .subscribe(
          res => {
            this.handleSuccess();
          },
          error => this.handleError(error),
          () => {}
        );
    }
    else{
    }
  }

  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
  }

  handleSuccess() {
    this.isRequestPending = false;
    this.emitData.status = 'success';
    this.emitter.emit(this.emitData);
  }

  handleError(error) {
    this.isRequestPending = false;
    this.emitData.status = 'error';
    this.emitter.emit(this.emitData);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/in-place-restore/in-place-restore.component.ts